import React, {useState, useEffect} from 'react';
import { Link, NavLink } from 'react-router-dom';
import { BsEnvelopeFill, BsFillPhoneFill, BsFillTelephoneFill, BsList, BsXLg, BsChevronDown, BsBoxArrowInRight } from "react-icons/bs";
import Button from './Button';
import logo from '../assets/images/uai-logo.png';
import axiosInstance from '../axiosInstance';


function Navbar() {
    const[dropopen, setDropopen] = useState(false);
    const onMouseEnter = () => {setDropopen(true)};
    const onMouseLeave = () => {setDropopen(false)};
    const [stickyClass, setStickyClass] = useState('relative');
    const [click, setClick] = useState(false);
    const changeClick = () => setClick(!click);
    //const closeMobileMenu = () => setClick(false);

    useEffect( () => {
        window.addEventListener('scroll', stickyNavbar);
        return () => {
            window.removeEventListener('scroll', stickyNavbar);
        };
    }, []);
    const stickyNavbar = () => {
        if(window !== undefined){
            let windowHeight = window.scrollY;
            windowHeight > 200 ? setStickyClass('fixed left-0 right-0 top-0 z-50 bg-white shadow-md') : setStickyClass('relative');
        }
    };
    const [contactData, setContactData] = useState([]);
    const [projectData, setProjectData] = useState([]);
    useEffect(() => {
        // const fetchData = async () => {
        //     try {
        //         const res = await axiosInstance.get("http://localhost:8081/api/fetchcontactnew"); // Adjust port if needed
        //         const fetchedData = res.data; // Assuming data is an array
        //         setContactData(fetchedData[0]);
        //     } catch (err) {
        //         console.error("Error fetching data:", err);
        //     }
        // };
        // fetchData();
        const fetchAllData = async () => {
            try {
                const token = localStorage.getItem("token");

                const [contactRes, projectRes] = await Promise.all([
                    axiosInstance.get('/api/fetchcontactnew', {
                        headers: {
                            Authorization: `${token}`,
                        }
                    }),
                    axiosInstance.get('/api/getprojects')
                ]);

                if (contactRes.data?.length > 0) {
                    setContactData(contactRes.data[0]);
                }

                if (projectRes.data?.length > 0) {
                    setProjectData(projectRes.data);
                }

            } catch (err) {
                console.error("Failed to fetch data:", err);
            }
        };

        fetchAllData();
    }, []);

    return (
        <div className='absolute left-0 top-0 w-full bg-transparent z-50'>
            <div className='topbar hidden relative md:flex items-center justify-center z-0 text-sm bg-slate-800 bg-opacity-80'>
                <div className='container mx-auto'>
                    <div className='flex items-center justify-between text-white py-1'>
                        <div className='contact-info flex items-start'>
                            {contactData?.email?.[0] && (
                            <div className='flex items-center justify-start ml-3 pr-3 border-e border-slate-400'>
                                <div className='shrink-0'>
                                    <BsEnvelopeFill />
                                </div>
                                <Link to={`mailto:${contactData.email[0]}`} className='ml-2 hover:text-orange-300'>{contactData.email[0]}</Link>
                            </div>
                            )}
                            <div className='flex items-center justify-start ml-3 pr-3'>
                                <div className='shrink-0'>
                                    <BsFillPhoneFill />
                                </div>
                                {contactData?.mobile?.map((mobile, idx) => (<span key={idx} className='ml-2'>+91-{mobile} {idx !== contactData.mobile.length - 1 && ', '}</span>))}
                                {/* <Link to="" className='ml-2'>9876543210</Link> */}
                            </div>
                            {/* <div className='flex items-center justify-start ml-3 pr-3'>
                                <div className='shrink-0'>
                                    <BsFillTelephoneFill />
                                </div>
                                <Link to="" className='ml-2'>0120-2546354</Link>
                            </div> */}
                        </div>
                        <div className='contact-button flex items-center justify-center'>                            
                            <div className='flex items-center justify-start ml-3'>
                                <Link to='#' variant='primary' className='hover:bg-orange-700 rounded flex flex-row bg-orange-500 text-white text-sm px-3 py-1 items-center transform duration-200'><span className='mr-2'>Login</span><BsBoxArrowInRight className='text-base' /></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <header className={`flex items-center justify-center z-0 text-sm bg-transparent ${stickyClass}`}>
                <div className='container mx-auto'>
                    <nav className='flex items-center justify-between text-black bg-white rounded py-2 px-2'>
                        <Link to="" className='px-2 w-2/3 md:w-1/2 lg:w-1/3'><img src={logo} alt={'Urbanaid Infratech'} className={`w-full sm:w-2/3 md:w-2/3 lg:w-2/4 h-auto`} /></Link>
                        <div className='flex items-center md:order-2 md:hidden'>
                            <button className='text-black bg-slate-300 cursor-pointer px-2 py-2 rounded text-base' onClick={changeClick}>
                            {click ? <BsXLg /> : <BsList /> }
                            </button>
                        </div>
                        <div className={`${click ? 'nav-element-visible' : 'nav-element-hidden'} md:relative md:justify-between md:items-center w-full md:flex md:w-auto md:h-auto md:order-1`} id='main-menu'>
                            <ul className='flex flex-col items-center justify-start md:flex-row w-full md:flex md:w-auto md:space-x-0 font-poppins'>
                                <li className={`${click ? 'w-full text-left border-b border-gray-200 border-solid' : '' }`}>
                                    <NavLink to={"/"} className='nav-link block items-center px-4 py-2 text-black bg-transparent decoration-0 uppercase font-semibold hover:text-orange-500'>Home</NavLink>
                                </li>
                                <li className={`${click ? 'w-full text-left border-b border-gray-200 border-solid' : '' }`}>
                                    <NavLink to={"/about-us"} className='nav-link block px-4 py-2 text-black bg-transparent decoration-0 uppercase font-semibold hover:text-orange-500'>About Us</NavLink>
                                </li>
                                {Array.isArray(projectData) && projectData.length > 0 && (
                                <li className={`${click ? 'w-full text-left border-b border-gray-200 border-solid' : '' } relative`} onMouseLeave={onMouseLeave}>
                                    <NavLink type="button" className='nav-link flex items-center px-4 py-2 text-black bg-transparent decoration-0 uppercase font-semibold hover:text-orange-500' onMouseEnter={onMouseEnter}>Our Projects <BsChevronDown className='ms-2 text-xs' /></NavLink>
                                    <div className={"z-10 absolute font-normal bg-white divide-y divide-gray-100 rounded-lg shadow min-w-[250px] dark:bg-gray-700 dark:divide-gray-600 transition-all duration-300 ease-in-out overflow-hidden" + (dropopen ? ' opacity-100 translate-y-0 pointer-events-auto' : ' opacity-0 -translate-y-4 pointer-events-none')}>
                                    <ul className="py-2 text-sm text-gray-700 dark:text-gray-400" aria-labelledby="dropdownLargeButton">
                                        {projectData.map((project) => {
                                            const projectUrl = project.projectname?.toLowerCase().replace(/\s+/g, "-") || "";
                                            return (
                                                <li key={project.id ?? project.projectname}><Link to={`/projects/${projectUrl}`} className="flex w-full items-center px-3 py-2 text-sm hover:bg-gray-100">
                                                    {project.projectname}
                                                    </Link>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                    </div>
                                </li>)}
                                <li className={`${click ? 'w-full text-left border-b border-gray-200 border-solid' : '' }`}>
                                    <NavLink to={'/videos'} className='nav-link block px-4 py-2 text-black bg-transparent decoration-0 uppercase font-semibold hover:text-orange-500'>Videos</NavLink>
                                </li>
                                <li className={`${click ? 'w-full text-left border-b border-gray-200 border-solid' : '' }`}>
                                    <NavLink to={'/contact-us'} className='nav-link block px-4 py-2 text-black bg-transparent decoration-0 uppercase font-semibold hover:text-orange-500'>Contact Us</NavLink>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </header>
        </div>
    );
}

export default Navbar;